import React, { Component } from 'react'

import * as utils from "../../utils";

import FeedComment from "./feed-comment";
import FeedPostMenu from "./feed-post-menu";
import TimeSince from "../../common/components/time-since";
import UserAvatar from "../../avatars/components";
import UserProfileLink from "../../common/components/user-profile-link";

export default function FeedPostHead(props) {
  const post = props.post;
  const { id, created, comment, mentions, tags, comment_edited, content, post_type } = post;
  const { first_name, last_name } = post.creator;
  const userId = post.creator.id;
  const truncateCommentAt = props.truncateCommentAt;
  let canDeleteEventItem = utils.canDeleteEventItem(userId);
  if (props.showMenu !== undefined) {
    // This is a little hacky but required since we don't allow delete from
    // the slideshow b/c multi-photo posts...
    canDeleteEventItem = props.showMenu;
  }
  return (
    <div className="post-head">
      <UserAvatar
        userId={userId}
        firstName={first_name}
        lastName={last_name}
        size="small"
      />
      <UserProfileLink
        userId={userId}
        firstName={first_name}
        lastName={last_name}
      />
      <TimeSince timestamp={created} />
      <FeedComment
        postId={id}
        comment={comment}
        commentEdited={comment_edited}
        truncateCommentAt={truncateCommentAt}
        tags={tags}
        mentions={mentions}
      />
      { canDeleteEventItem &&
        <FeedPostMenu
          comment={comment}
          postId={id}
          userId={userId}
          tags={tags}
          mentions={mentions}
          postType={post_type}
        />
      }
    </div>
  )
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/feed-post-head.es6